import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { SeFeButtonModule } from 'se-fe-button'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { SeFeFormFieldModule } from 'se-fe-form-field'
import { SeFeFormFieldTextModule } from 'se-fe-form-field-text'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'
import { SharedFeatureRegistrationListModule } from '../lib/shared-feature-registration-list.module'
import { RegistrationListDocsComponent } from './registration-list-docs/registration-list-docs.component'
import { RegistrationListExampleComponent } from './registration-list-docs/registration-list-example.component'

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SeFeButtonModule,
    SeFeCardModule,
    SeFeDocsExampleModule,
    SeFeFormFieldModule,
    SeFeFormFieldTextModule,
    SeFeHeaderModule,
    SeFePageModule,
    SharedFeatureRegistrationListModule
  ],
  declarations: [
    RegistrationListDocsComponent,
    RegistrationListExampleComponent
  ],
  exports: [
    RegistrationListDocsComponent
  ]
})
export class SharedFeatureRegistrationListDocsModule {}
